import React, { useContext, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormControl,
  Row,
} from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import { useParams } from "react-router-dom";
import HeaderBanner from "../Components/HeaderBanner";
import Config from "../config.json";
import ComponentContext from "../Context";
import Kargah from "../Images/kargah.png";
import Statics from "../Statics";
import getSuccessfulLoginUrl, { clearSuccessfulLoginData } from "../lib/auth";
import {
  getPersianApiErrorMessage,
  isUnauthorizedApiError,
} from "../lib/apiErrorMessages";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | ثبت نام کارگاه",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const body = `به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده است. برای
      درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم عمومی ثبت نام فرمایید.`;

const WorkShopRegister = () => {
  const { workshop_id } = useParams();

  const context = useContext(ComponentContext);
  const loginUrl = getSuccessfulLoginUrl(`/workshop/register/${workshop_id}`);

  const [workshop, set_workshop] = useState(null);
  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);
  const [form_first_name, set_form_first_name] = useState("");
  const [form_last_name, set_form_last_name] = useState("");
  const [form_gender, set_form_gender] = useState("");
  const [form_id_number, set_id_number] = useState("");
  const [form_grade, set_form_grade] = useState("");
  const [form_field, set_form_field] = useState("");
  const [form_university, set_form_university] = useState("");
  const [form_email, set_form_email] = useState("");
  const [form_phone, set_form_phone] = useState("");
  const [form_address, set_form_address] = useState("");
  const [form_job, set_form_job] = useState("");
  const [form_birth_date_year, set_form_birth_date_year] = useState("");
  const [form_birth_date_month, set_form_birth_date_month] = useState("");
  const [form_birth_date_day, set_form_birth_date_day] = useState("");
  const [requesting, set_requesting] = useState(false);

  const getWorkshop = () => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.searchWorkshops(
      { workshop_id },
      (data, meta) => {
        set_workshop(data.data[0]);
        set_loading_state(Statics.LOADED);
      },
      error => {
        set_loading_state(Statics.CAUSED_ERROR);
      },
    );
  };

  const registerWorkShop = () => {
    const requiredFields = [
      [form_gender, "جنسیت"],
      [form_first_name.trim(), "نام"],
      [form_last_name.trim(), "نام خانوادگی"],
      [form_id_number.trim(), "کد ملی"],
      [form_phone.trim(), "شماره تلفن"],
      [form_email.trim(), "ایمیل"],
    ];
    const missingField = requiredFields.find(([value]) => !value);
    if (missingField) {
      context.notification(`لطفاً ${missingField[1]} را وارد کنید.`, "error");
      return;
    }
    set_requesting(true);
    const formData = {};
    formData.first_name = form_first_name;
    formData.last_name = form_last_name;
    formData.gender = Number(form_gender);
    formData.id_number = form_id_number;
    formData.job = form_job;
    formData.grade = form_grade;
    formData.field = form_field;
    formData.university = form_university;
    formData.email = form_email;
    formData.phone = form_phone;
    formData.address = form_address;
    formData.birth_date =
      form_birth_date_year && form_birth_date_month && form_birth_date_day
        ? `${form_birth_date_year}-${form_birth_date_month}-${form_birth_date_day}`
        : "";
    formData.workshop_id = workshop_id;
    context.ApiDriver.registerInWorkshop(
      formData,
      (data, meta) => {
        set_requesting(false);
        window.location = `/workshop/register/detail/${data.register_request_id}`;
      },
      error => {
        set_requesting(false);
        if (isUnauthorizedApiError(error)) {
          clearSuccessfulLoginData();
          context.cookie.remove("pajoohyar_access_token");
          context.cookie.remove("pajoohyar_expires_at");
          context.cookie.remove("pajoohyar_profile");
          context.ApiDriver.access_token = null;
          context.ApiDriver.expires_at = null;
          context.profile = null;

          context.notification(
            "نشست شما منقضی شده است. لطفاً دوباره وارد شوید.",
            "error",
          );
          const freshLoginUrl = getSuccessfulLoginUrl(
            `/workshop/register/${workshop_id}`,
          );
          window.setTimeout(() => {
            window.location.assign(freshLoginUrl);
          }, 1200);
          return;
        }

        const validationErrors = error?.response?.data?.errors || {};
        for (const err in validationErrors) {
          const element = document.getElementById(
            err,
          );
          if (element) {
            element.className += " invalid-forminput";
          }
        }
        context.notification(
          getPersianApiErrorMessage(
            error,
            "ثبت‌نام انجام نشد. لطفاً دوباره تلاش کنید.",
          ),
          "error",
        );
      },
    );
  };

  if (loading_state === Statics.NOT_LOADED) {
    getWorkshop();
  }

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#E5E1DA" />
      {loading_state === Statics.LOADED && workshop ? (
        <Row className="mx-0 fdfdf" style={{ padding: "50px 30px" }}>
          <Col>
            <Row className="workshop-details mx-0 justify-content-center">
              <Col md={12} className="d-flex">
                <Card className="d-flex ws-card">
                  <Card.Body className="text-right">
                    <Card.Title>{workshop.title}</Card.Title>
                    <Card.Text
                      style={{ border: "1px solid #9f9999", borderRadius: 18 }}>
                      <Row className="mx-0">
                        <Col
                          className="p-3"
                          style={{
                            borderLeft: "1px solid #9f9999",
                          }}>
                          {" "}
                          <Row className="mx-0">ظرفیت: {workshop.capacity}</Row>
                          <Row className="mx-0">
                            نوع کارگاه: {workshop.type.text}
                          </Row>
                        </Col>
                        <Col
                          className="p-3"
                          style={{
                            borderLeft: "1px solid #9f9999",
                          }}>
                          {workshop.meetings.data.length > 1 ? (
                            workshop.meetings.data.map((session, index) => (
                              <Row className="mx-0" key={index}>
                                <p>
                                  جلسه {index + 1}:{" "}
                                  <label>
                                    {session.start_date.year +
                                      "/" +
                                      session.start_date.month +
                                      "/" +
                                      session.start_date.day +
                                      "   " +
                                      session.start_date.hour +
                                      ":" +
                                      ("0" + session.start_date.minute).slice(
                                        -2,
                                      )}
                                  </label>
                                  {" تا "}
                                  <label>
                                    {session.finish_date.hour +
                                      ":" +
                                      ("0" + session.finish_date.minute).slice(
                                        -2,
                                      )}
                                  </label>
                                </p>
                              </Row>
                            ))
                          ) : workshop.meetings.data.length === 1 ? (
                            <Row className="mx-0">
                              <p>
                                جلسه 1:{" "}
                                <label>
                                  {workshop.meetings.data[0].start_date.year +
                                    "/" +
                                    workshop.meetings.data[0].start_date.month +
                                    "/" +
                                    workshop.meetings.data[0].start_date.day +
                                    "   " +
                                    workshop.meetings.data[0].start_date.hour +
                                    ":" +
                                    (
                                      "0" +
                                      workshop.meetings.data[0].start_date
                                        .minute
                                    ).slice(-2)}
                                </label>
                                {" تا "}
                                <label>
                                  {workshop.meetings.data[0].finish_date.hour +
                                    ":" +
                                    (
                                      "0" +
                                      workshop.meetings.data[0].finish_date
                                        .minute
                                    ).slice(-2)}
                                </label>
                              </p>
                            </Row>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col className="p-3">
                          <Row className="mx-0">
                            قیمت:
                            {workshop.offered_fee === workshop.fee ? (
                              <b>{workshop.fee} تومان</b>
                            ) : (
                              <p>
                                <del style={{ color: "red" }}>
                                  {workshop.fee} تومان
                                </del>
                                <br />
                                <b>{workshop.offered_fee} تومان</b>
                              </p>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    </Card.Text>

                    {context.ApiDriver.access_token ? (
                      <Col className="cslformcontainer workshop-register-form">
                        <div className="workshop-form-heading"><div><h3>اطلاعات ثبت‌نام</h3><p>فیلدهای ستاره‌دار برای ثبت‌نام ضروری هستند.</p></div></div>
                        <Row className="workshop-form-row">
                          <Col lg={3} md={6} className="px-2"><Form.Group><Form.Label>نام <b>*</b></Form.Label><FormControl id="first_name" value={form_first_name} onChange={e => set_form_first_name(e.target.value)} /></Form.Group></Col>
                          <Col lg={3} md={6} className="px-2"><Form.Group><Form.Label>نام خانوادگی <b>*</b></Form.Label><FormControl id="last_name" value={form_last_name} onChange={e => set_form_last_name(e.target.value)} /></Form.Group></Col>
                          <Col lg={3} md={6} className="px-2"><Form.Group><Form.Label>کد ملی <b>*</b></Form.Label><FormControl id="id_number" inputMode="numeric" onChange={e => set_id_number(e.target.value)} /></Form.Group></Col>
                          <Col lg={3} md={6} className="px-2"><Form.Group><Form.Label>شماره تلفن <b>*</b></Form.Label><FormControl id="phone" inputMode="tel" placeholder="۰۹۱۲۱۲۳۴۵۶۷" onChange={e => set_form_phone(e.target.value)} /></Form.Group></Col>
                          <Col lg={3} md={6} className="px-2"><Form.Group><Form.Label>جنسیت <b>*</b></Form.Label><Form.Control id="gender" as="select" value={form_gender} onChange={e => set_form_gender(e.target.value)}><option value="">انتخاب کنید</option><option value="1">آقا</option><option value="2">خانم</option></Form.Control></Form.Group></Col>
                          <Col lg={3} md={6} className="px-2"><Form.Group><Form.Label>ایمیل <b>*</b></Form.Label><FormControl id="email" type="email" dir="ltr" value={form_email} onChange={e => set_form_email(e.target.value)} /></Form.Group></Col>
                        </Row>
                        <div className="workshop-optional-fields">
                          <div className="workshop-optional-title">اطلاعات تکمیلی <span>اختیاری</span></div>
                          <Row className="mx-0 workshop-form-row">
                            <Col md={3} sm={6} className="px-2"><Form.Group><Form.Label>نام دانشگاه</Form.Label><FormControl id="university" onChange={e => set_form_university(e.target.value)} /></Form.Group></Col>
                            <Col md={3} sm={6} className="px-2"><Form.Group><Form.Label>مقطع تحصیل</Form.Label><FormControl id="grade" onChange={e => set_form_grade(e.target.value)} /></Form.Group></Col>
                            <Col md={3} sm={6} className="px-2"><Form.Group><Form.Label>رشته تحصیل</Form.Label><FormControl id="field" onChange={e => set_form_field(e.target.value)} /></Form.Group></Col>
                            <Col md={3} sm={6} className="px-2"><Form.Group><Form.Label>شغل</Form.Label><FormControl id="job" onChange={e => set_form_job(e.target.value)} /></Form.Group></Col>
                            <Col md={6} className="px-2"><Form.Group><Form.Label>محل سکونت</Form.Label><FormControl id="address" onChange={e => set_form_address(e.target.value)} /></Form.Group></Col>
                            <Col md={6} className="px-2"><Form.Group><Form.Label>تاریخ تولد</Form.Label><div className="birth-date-fields"><FormControl min="1" max="31" type="number" placeholder="روز" onChange={e => set_form_birth_date_day(e.target.value)} /><FormControl min="1" max="12" type="number" placeholder="ماه" onChange={e => set_form_birth_date_month(e.target.value)} /><FormControl min="1300" max="1500" type="number" placeholder="سال" onChange={e => set_form_birth_date_year(e.target.value)} /></div></Form.Group></Col>
                          </Row>
                        </div>
                        <div className="workshop-form-actions"><Button bsPrefix="custom-button" disabled={requesting} onClick={registerWorkShop} style={{ fontSize: 14 }}>{requesting ? "در حال ثبت..." : "ثبت‌نام و ادامه"}</Button></div>
                      </Col>
                    ) : (
                      <Col>
                        <Row className="mx-0">
                          <h3>
                            لطفا جهت ثبت نام در کارگاه{" "}
                            <a href={loginUrl}>وارد</a> شوید.
                          </h3>
                        </Row>
                      </Col>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        ""
      )}
    </DocumentMeta>
  );
};

export default WorkShopRegister;
